export const smartiLabHelpCopy = {
  overview: {
    titleIt: 'Panoramica Smarti Lab',
    bodyIt: 'Smarti Lab legge produzione e burn-in, cerca segnali ricorrenti e mostra dove indagare prima. I risultati indicano priorità, non cause confermate.',
    bulletsIt: [
      'Usa test di produzione, burn-in collegabile e ultimo run ML.',
      'Qualità dati debole significa più cautela e minore confidenza.',
    ],
    titleEn: 'Smarti Lab overview',
    bodyEn: 'Smarti Lab reads production and burn-in data, looks for recurring signals, and shows where to investigate first. Results indicate priorities, not confirmed causes.',
    bulletsEn: [
      'It uses production tests, linkable burn-in data, and the latest ML run.',
      'Weak data quality means more caution and lower confidence.',
    ],
  },
  mlFusionMode: {
    titleIt: 'Modalità ML / Fusion',
    bodyIt: 'La modalità ML/Fusion unisce test di produzione e dati burn-in collegabili. Normalizza i passaggi, valuta rischio, anomalie, collegamenti e confronti con unità sane. Il risultato è una priorità di indagine, non una causa confermata.',
    bulletsIt: [
      'Il burn-in pesa di più solo se il link è affidabile.',
      'La confidenza scende con pochi dati o link ambigui.',
    ],
    titleEn: 'ML / Fusion mode',
    bodyEn: 'ML/Fusion mode combines production tests with linkable burn-in data. It normalizes steps, evaluates risk, anomalies, links, and comparisons with healthy units. The result is an investigation priority, not a confirmed cause.',
    bulletsEn: [
      'Burn-in matters more only when the link is reliable.',
      'Confidence drops with limited data or ambiguous links.',
    ],
  },
  runAnalysis: {
    titleIt: 'Esegui analisi',
    bodyIt: 'Avvia una nuova analisi Smarti Lab. Il sistema rilegge i database, ricostruisce i collegamenti produzione/burn-in, ricalcola profili di rischio, anomalie, derive e sospetti. I dati sorgente non vengono modificati.',
    bulletsIt: [
      'I database di produzione e burn-in vengono letti in sola lettura.',
      'Il database di analisi e gli artefatti runtime vengono rigenerati.',
      'La durata dipende da quantità dei dati e numero di righe da confrontare.',
    ],
    titleEn: 'Run analysis',
    bodyEn: 'Starts a new Smarti Lab analysis. The system rereads the databases, rebuilds production/burn-in links, recalculates risk profiles, anomalies, drift, and suspects. Source data is not modified.',
    bulletsEn: [
      'Production and burn-in databases are read only.',
      'The analysis database and runtime artifacts are regenerated.',
      'Run time depends on data volume and comparison workload.',
    ],
  },
  investigationReadiness: {
    titleIt: 'Readiness di indagine',
    bodyIt: 'Indica quanto i dati sono adatti a un’indagine affidabile. Il punteggio sale con più sessioni, più guasti osservati, misure numeriche valide, limiti disponibili e collegamenti burn-in chiari. Scende con dati mancanti, pochi guasti o collegamenti ambigui.',
    titleEn: 'Investigation readiness',
    bodyEn: 'Shows how suitable the data is for reliable investigation. The score improves with more sessions, observed failures, valid numeric measurements, available limits, and clear burn-in links. It drops with missing data, too few failures, or ambiguous links.',
  },
  dataQualityWarnings: {
    titleIt: 'Avvisi qualità dati',
    bodyIt: 'Questi avvisi indicano problemi che possono rendere i risultati meno affidabili: pochi guasti, limiti mancanti, misure non numeriche, timestamp non validi o collegamenti burn-in incerti.',
    titleEn: 'Data quality warnings',
    bodyEn: 'These warnings show issues that can make results less reliable: too few failures, missing limits, non-numeric measurements, invalid timestamps, or uncertain burn-in links.',
  },
  burnLinkConfidence: {
    titleIt: 'Confidenza collegamento burn-in',
    bodyIt: 'Misura quanto è credibile il collegamento tra un seriale di produzione e una sorgente burn-in. Il sistema usa somiglianza del testo, numeri estratti, code numeriche e, se possibile, vicinanza temporale. Se la confidenza è bassa o ambigua, il segnale burn-in pesa meno.',
    titleEn: 'Burn-in link confidence',
    bodyEn: 'Measures how credible the link is between a production serial and a burn-in source. The system uses text similarity, extracted numbers, numeric tails, and, when possible, time proximity. If confidence is low or ambiguous, burn-in evidence receives less weight.',
  },
  evidenceScore: {
    titleIt: 'Punteggio di evidenza',
    bodyIt: 'Combina fallimento del passaggio, pressione verso i limiti, anomalie, sequenza, rischio storico e burn-in. Più è alto, più il sospetto merita attenzione.',
    bulletsIt: [
      'Non è una probabilità di causa vera.',
      'Un valore alto significa: controllare prima questo sospetto.',
    ],
    titleEn: 'Evidence score',
    bodyEn: 'It combines step failure, limit pressure, anomalies, sequence role, historical risk, and burn-in. The higher it is, the more the suspect deserves attention.',
    bulletsEn: [
      'It is not a true-cause probability.',
      'A high value means: inspect this suspect first.',
    ],
  },
  suspectConfidence: {
    titleIt: 'Confidenza del sospetto',
    bodyIt: 'La confidenza indica quanto il punteggio è supportato dai dati. Aumenta con più casi coerenti, collegamenti chiari e pochi dati mancanti. Diminuisce quando il campione è piccolo, il collegamento burn-in è ambiguo o il segnale arriva da una sola fonte.',
    titleEn: 'Suspect confidence',
    bodyEn: 'Confidence shows how well the score is supported by data. It increases with more consistent cases, clear links, and little missing data. It decreases when the sample is small, the burn-in link is ambiguous, or the signal comes from only one source.',
  },
  cautionFlags: {
    titleIt: 'Flag di cautela',
    bodyIt: 'I flag di cautela spiegano perché un risultato va letto con prudenza: pochi dati, link burn-in ambiguo, misura mancante, limiti assenti, possibile sintomo a valle o nessuna conferma umana.',
    titleEn: 'Caution flags',
    bodyEn: 'Caution flags explain why a result should be read carefully: limited data, ambiguous burn-in link, missing measurement, absent limits, possible downstream symptom, or no human confirmation.',
  },
  rootCauseExplorer: {
    titleIt: 'Root Cause Explorer',
    bodyIt: 'Questa pagina raggruppa i passaggi che ricorrono come sospetti nelle sessioni guaste. Mostra evidenza, confidenza, supporto e motivi principali. Serve a trovare pattern ripetuti, non a dichiarare automaticamente la causa.',
    titleEn: 'Root Cause Explorer',
    bodyEn: 'This page groups steps that repeatedly appear as suspects in failed sessions. It shows evidence, confidence, support, and main reasons. It is used to find repeated patterns, not to automatically declare the cause.',
  },
  strictSuspects: {
    titleIt: 'Sospetti strict',
    bodyIt: 'I sospetti strict superano filtri più severi: supporto sufficiente, buona confidenza, pochi link ambigui e minore rischio di essere solo sintomi a valle.',
    titleEn: 'Strict suspects',
    bodyEn: 'Strict suspects pass stricter filters: enough support, good confidence, few ambiguous links, and lower risk of being only downstream symptoms.',
  },
  unitDetail: {
    titleIt: 'Dettaglio unità',
    bodyIt: 'Questa pagina mostra l’indagine di una singola unità: timeline dei passaggi, primo guasto visibile, sospetti principali, confronto con unità passate simili, segnali burn-in e anomalie di misura.',
    titleEn: 'Unit detail',
    bodyEn: 'This page shows the investigation for one unit: step timeline, first visible failure, top suspects, comparison with similar passing units, burn-in signals, and measurement anomalies.',
  },
  firstVisibleFailure: {
    titleIt: 'Primo guasto visibile',
    bodyIt: 'È il primo passaggio che risulta fallito nella sequenza del test. Può essere la causa, ma può anche essere il primo punto in cui un problema precedente diventa visibile.',
    titleEn: 'First visible failure',
    bodyEn: 'This is the first step that failed in the test sequence. It can be the cause, but it can also be the first point where an earlier problem becomes visible.',
  },
  upstreamContributor: {
    titleIt: 'Contributore a monte',
    bodyIt: 'Un possibile contributore a monte appare prima del primo guasto visibile e mostra segnali anomali o ricorrenti. È spesso più interessante del passaggio che fallisce per primo.',
    titleEn: 'Upstream contributor',
    bodyEn: 'A possible upstream contributor appears before the first visible failure and shows abnormal or recurring signals. It is often more interesting than the first step that fails.',
  },
  downstreamSymptom: {
    titleIt: 'Sintomo a valle',
    bodyIt: 'Un sintomo a valle appare dopo che il problema è già visibile. Può fallire perché il sistema è già in errore, quindi pesa meno come causa iniziale.',
    titleEn: 'Downstream symptom',
    bodyEn: 'A downstream symptom appears after the problem is already visible. It may fail because the system is already in error, so it carries less weight as an initial cause.',
  },
  passTwinComparison: {
    titleIt: 'Confronto con unità passate simili',
    bodyIt: 'Confronta un’unità guasta con unità passate simili per stazione, Testspec, macchina, versione ATE e sequenza dei passaggi. Le differenze forti aiutano a capire cosa rende questa unità diversa dalle unità sane.',
    titleEn: 'Pass twin comparison',
    bodyEn: 'Compares a failed unit with similar passing units by station, Testspec, machine, ATE version, and step sequence. Strong differences help identify what makes this unit different from healthy units.',
  },
  anomalyScore: {
    titleIt: 'Punteggio di anomalia',
    bodyIt: 'Misura quanto una misura è insolita rispetto alla distribuzione storica dello stesso passaggio. Considera distanza dalla mediana, variabilità normale e pressione verso i limiti.',
    titleEn: 'Anomaly score',
    bodyEn: 'Measures how unusual a measurement is compared with the historical distribution of the same step. It considers distance from the median, normal variability, and pressure toward limits.',
  },
  limitPressure: {
    titleIt: 'Pressione verso i limiti',
    bodyIt: 'Indica quanto una misura è vicina al limite minimo o massimo. Una misura può essere ancora PASS ma già molto vicina al limite, quindi utile come segnale precoce.',
    titleEn: 'Limit pressure',
    bodyEn: 'Shows how close a measurement is to the lower or upper limit. A measurement can still PASS but already be very close to the limit, making it useful as an early signal.',
  },
  driftAlerts: {
    titleIt: 'Avvisi di deriva',
    bodyIt: 'Segnalano cambiamenti recenti rispetto allo storico: più guasti, più anomalie o misure più vicine ai limiti su una stazione, macchina, versione ATE o passaggio.',
    titleEn: 'Drift alerts',
    bodyEn: 'Flags recent changes compared with history: more failures, more anomalies, or measurements closer to limits on a station, machine, ATE version, or step.',
  },
  failureFamilies: {
    titleIt: 'Famiglie di guasto / cluster',
    bodyIt: 'Raggruppano sessioni con segnali simili: stessi passaggi sospetti, sequenze simili, contesto simile o anomalie ricorrenti. Aiutano a vedere se un guasto appartiene a un pattern già osservato.',
    titleEn: 'Failure families / clusters',
    bodyEn: 'Groups sessions with similar signals: same suspect steps, similar sequences, similar context, or recurring anomalies. They help show whether a failure belongs to a pattern already seen.',
  },
  stepRiskProfile: {
    titleIt: 'Profilo di rischio del passaggio',
    bodyIt: 'Mostra quanto un passaggio è storicamente associato a guasti o segnali deboli. Il rischio viene calcolato con correzioni statistiche per evitare conclusioni forti su pochi casi.',
    titleEn: 'Step risk profile',
    bodyEn: 'Shows how strongly a step has historically been associated with failures or weak signals. Risk is calculated with statistical smoothing to avoid strong conclusions from too few cases.',
  },
  bayesianRisk: {
    titleIt: 'Rischio bayesiano corretto',
    bodyIt: 'Il rischio corretto evita di esagerare quando ci sono pochi dati. Un passaggio con 1 guasto su 1 caso non viene trattato automaticamente come più rischioso di uno con molti casi coerenti.',
    titleEn: 'Bayesian / smoothed risk',
    bodyEn: 'Smoothed risk avoids overreacting when data is limited. A step with 1 failure in 1 case is not automatically treated as riskier than one with many consistent cases.',
  },
  weakBaselineModel: {
    titleIt: 'Modello baseline debole',
    bodyIt: 'Questo modello è un riferimento tecnico, non una prova di causa. Usa etichette deboli ricavate dai dati, quindi le metriche indicano coerenza del ranking, non verità diagnostica.',
    titleEn: 'Weak baseline model',
    bodyEn: 'This model is a technical baseline, not proof of cause. It uses weak labels derived from the data, so metrics show ranking consistency, not diagnostic truth.',
  },
  humanConfirmation: {
    titleIt: 'Conferma umana',
    bodyIt: 'La conferma umana serve a trasformare un sospetto in un’etichetta affidabile. Quando un tecnico conferma o rifiuta un sospetto, Smarti Lab può imparare meglio nei cicli successivi.',
    titleEn: 'Human confirmation',
    bodyEn: 'Human confirmation turns a suspect into a reliable label. When a technician confirms or rejects a suspect, Smarti Lab can learn better in future cycles.',
  },
  noMlRun: {
    titleIt: 'Nessuna analisi eseguita',
    bodyIt: 'Nessuna analisi Smarti Lab è stata eseguita. Avvia l’analisi per leggere i dati, costruire i collegamenti produzione/burn-in e generare sospetti basati su evidenze.',
    titleEn: 'No analysis run yet',
    bodyEn: 'No Smarti Lab analysis has been run yet. Start the analysis to read the data, build production/burn-in links, and generate evidence-based suspects.',
  },
  noRootCauseSuspects: {
    titleIt: 'Nessun sospetto ricorrente',
    bodyIt: 'Nessun sospetto ricorrente trovato con i filtri attuali. Prova a ridurre i filtri o controlla gli avvisi sulla qualità dei dati.',
    titleEn: 'No recurring suspects',
    bodyEn: 'No recurring suspects found with the current filters. Try reducing the filters or check the data quality warnings.',
  },
  noBurnInLinks: {
    titleIt: 'Nessun collegamento burn-in affidabile',
    bodyIt: 'Nessun collegamento burn-in affidabile trovato. L’analisi usa solo i dati di produzione e riduce il peso dei segnali burn-in.',
    titleEn: 'No reliable burn-in links',
    bodyEn: 'No reliable burn-in link was found. The analysis uses production data only and reduces the weight of burn-in signals.',
  },
  noDriftAlerts: {
    titleIt: 'Nessuna deriva rilevante',
    bodyIt: 'Nessuna deriva rilevante rilevata con i dati attuali. Questo non esclude problemi: significa solo che non emerge un cambiamento recente abbastanza forte.',
    titleEn: 'No relevant drift alerts',
    bodyEn: 'No relevant drift detected with the current data. This does not rule out problems: it only means no recent change is strong enough to stand out.',
  },
  noPassTwins: {
    titleIt: 'Confronto con pass twin non disponibile',
    bodyIt: 'Non ci sono abbastanza unità passate simili per un confronto affidabile. Il sospetto resta basato sugli altri canali di evidenza.',
    titleEn: 'No pass twins available',
    bodyEn: 'There are not enough similar passing units for a reliable comparison. The suspect remains based on the other evidence channels.',
  },
  missingFusionDb: {
    titleIt: 'Database di analisi assente',
    bodyIt: 'Il database di analisi non esiste ancora. Esegui una nuova analisi Smarti Lab.',
    titleEn: 'Missing analysis database',
    bodyEn: 'The analysis database does not exist yet. Run a new Smarti Lab analysis.',
  },
  oldSchema: {
    titleIt: 'Schema ML non aggiornato',
    bodyIt: 'Il database di analisi esiste, ma non contiene ancora le nuove tabelle ML. Esegui di nuovo l’analisi.',
    titleEn: 'Old ML schema',
    bodyEn: 'The analysis database exists, but it does not contain the new ML tables yet. Run the analysis again.',
  },
  runFailed: {
    titleIt: 'Analisi non completata',
    bodyIt: 'L’analisi non è stata completata. Controlla il messaggio tecnico e verifica che i database sorgente siano disponibili.',
    titleEn: 'Run failed',
    bodyEn: 'The analysis did not complete. Check the technical message and verify that the source databases are available.',
  },
};

export function getSmartiLabLocaleCopy(copy, language) {
  const isItalian = language !== 'en';
  return {
    title: isItalian ? copy.titleIt : copy.titleEn,
    body: isItalian ? copy.bodyIt : copy.bodyEn,
    bullets: isItalian ? copy.bulletsIt : copy.bulletsEn,
  };
}
